/*!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
* GRL_MODIFY: Modified from codegen version. GRL_MODIFY marks changes
!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!*/
/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Divider,
  Flex,
  Grid,
  Heading,
  Text,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { BusinessPlanningHorizon } from "../models";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { DataStore } from "aws-amplify/datastore";
export default function BusinessPlanningHorizonCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    presets, // GRL_MODIFY: add presets prop
    ...rest
  } = props;
  const initialValues = {
    BusinessPlanningHorizonName: "",
    BusinessPlanningHorizonDescription: "",
    HorizonStart: "",
    HorizonEnd: "",
    ...presets // GRL_MODIFY: add presets to initial values
  };
  const [BusinessPlanningHorizonName, setBusinessPlanningHorizonName] =
    React.useState(initialValues.BusinessPlanningHorizonName);
  const [
    BusinessPlanningHorizonDescription,
    setBusinessPlanningHorizonDescription,
  ] = React.useState(initialValues.BusinessPlanningHorizonDescription);
  const [HorizonStart, setHorizonStart] = React.useState(
    initialValues.HorizonStart
  );
  const [HorizonEnd, setHorizonEnd] = React.useState(initialValues.HorizonEnd);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setBusinessPlanningHorizonName(initialValues.BusinessPlanningHorizonName);
    setBusinessPlanningHorizonDescription(
      initialValues.BusinessPlanningHorizonDescription
    );
    setHorizonStart(initialValues.HorizonStart);
    setHorizonEnd(initialValues.HorizonEnd);
    setErrors({});
  };
  const validations = {
    BusinessPlanningHorizonName: [],
    BusinessPlanningHorizonDescription: [],
    HorizonStart: [],
    HorizonEnd: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          BusinessPlanningHorizonName,
          BusinessPlanningHorizonDescription,
          HorizonStart,
          HorizonEnd,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await DataStore.save(new BusinessPlanningHorizon(modelFields));
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "BusinessPlanningHorizonCreateForm")}
      {...rest}
    >
      <Heading
        level={4}
        children="Business Strategic Planning Horizon"
        {...getOverrideProps(overrides, "SectionalElement0")}
      ></Heading>
      <Heading
        children="IFRS S2 paragraph 10 d."
        {...getOverrideProps(overrides, "SectionalElement1")}
      ></Heading>
      <Text
        children="Create a record that defines a planning horizon you use for strategic decision-making."
        {...getOverrideProps(overrides, "SectionalElement2")}
      ></Text>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement3")}
      ></Divider>
      <TextField
        label="Planning horizon name"
        isRequired={false}
        isReadOnly={false}
        value={BusinessPlanningHorizonName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              BusinessPlanningHorizonName: value,
              BusinessPlanningHorizonDescription,
              HorizonStart,
              HorizonEnd,
            };
            const result = onChange(modelFields);
            value = result?.BusinessPlanningHorizonName ?? value;
          }
          if (errors.BusinessPlanningHorizonName?.hasError) {
            runValidationTasks("BusinessPlanningHorizonName", value);
          }
          setBusinessPlanningHorizonName(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "BusinessPlanningHorizonName",
            BusinessPlanningHorizonName
          )
        }
        errorMessage={errors.BusinessPlanningHorizonName?.errorMessage}
        hasError={errors.BusinessPlanningHorizonName?.hasError}
        {...getOverrideProps(overrides, "BusinessPlanningHorizonName")}
      ></TextField>
      <TextAreaField
        label="Planning horizon description"
        isRequired={false}
        isReadOnly={false}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              BusinessPlanningHorizonName,
              BusinessPlanningHorizonDescription: value,
              HorizonStart,
              HorizonEnd,
            };
            const result = onChange(modelFields);
            value = result?.BusinessPlanningHorizonDescription ?? value;
          }
          if (errors.BusinessPlanningHorizonDescription?.hasError) {
            runValidationTasks("BusinessPlanningHorizonDescription", value);
          }
          setBusinessPlanningHorizonDescription(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "BusinessPlanningHorizonDescription",
            BusinessPlanningHorizonDescription
          )
        }
        errorMessage={errors.BusinessPlanningHorizonDescription?.errorMessage}
        hasError={errors.BusinessPlanningHorizonDescription?.hasError}
        	value={BusinessPlanningHorizonDescription} // GRL_MODIFY: correct value prop
        {...getOverrideProps(overrides, "BusinessPlanningHorizonDescription")}
      ></TextAreaField>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid6")}
      >
        <TextField
          label="Horizon start"
          isRequired={false}
          isReadOnly={false}
          type="date"
          value={HorizonStart}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                BusinessPlanningHorizonName,
                BusinessPlanningHorizonDescription,
                HorizonStart: value,
                HorizonEnd,
              };
              const result = onChange(modelFields);
              value = result?.HorizonStart ?? value;
            }
            if (errors.HorizonStart?.hasError) {
              runValidationTasks("HorizonStart", value);
            }
            setHorizonStart(value);
          }}
          onBlur={() => runValidationTasks("HorizonStart", HorizonStart)}
          errorMessage={errors.HorizonStart?.errorMessage}
          hasError={errors.HorizonStart?.hasError}
          {...getOverrideProps(overrides, "HorizonStart")}
        ></TextField>
        <TextField
          label="Horizon end"
          isRequired={false}
          isReadOnly={false}
          type="date"
          value={HorizonEnd}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                BusinessPlanningHorizonName,
                BusinessPlanningHorizonDescription,
                HorizonStart,
                HorizonEnd: value,
              };
              const result = onChange(modelFields);
              value = result?.HorizonEnd ?? value;
            }
            if (errors.HorizonEnd?.hasError) {
              runValidationTasks("HorizonEnd", value);
            }
            setHorizonEnd(value);
          }}
          onBlur={() => runValidationTasks("HorizonEnd", HorizonEnd)}
          errorMessage={errors.HorizonEnd?.errorMessage}
          hasError={errors.HorizonEnd?.hasError}
          {...getOverrideProps(overrides, "HorizonEnd")}
        ></TextField>
      </Grid>
      <Divider
        orientation="horizontal"
        {...getOverrideProps(overrides, "SectionalElement4")}
      ></Divider>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
